import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // 1. Reset scroll to top smoothly when navigating to a new page/route
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  // 2. Smoothly scroll to top when clicking a link that points to the current active page
  useEffect(() => {
    const handleSamePageLinkClick = (e) => {
      // Find the nearest parent anchor element <a>
      const anchor = e.target.closest("a");
      if (anchor) {
        try {
          const targetUrl = new URL(anchor.href, window.location.origin);

          // Only scroll if:
          // - The target path matches the current path
          // - The link does NOT contain a hash tag (e.g. href="/#booking" should still jump to the section)
          if (targetUrl.pathname === window.location.pathname && !targetUrl.hash) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }
        } catch (error) {
          console.error("ScrollToTop error:", error);
        }
      }
    };

    document.addEventListener("click", handleSamePageLinkClick);
    return () => {
      document.removeEventListener("click", handleSamePageLinkClick);
    };
  }, []);

  return null;
}